import React from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';

/**
 * Legacy route: /club/:clubId/session-wrap-up → Review sessions.
 */
const ClubSessionWrapUpRedirect = () => {
  const { clubId } = useParams();
  const location = useLocation();
  return (
    <Navigate
      to={`/club/${clubId}/sessions/review`}
      replace
      state={location.state}
    />
  );
};

export default ClubSessionWrapUpRedirect;
